<a [routerLink]="redirectUrl">
  <img alt="website logo" class="myre-header__logo" [src]="logoUrl" />
</a>
